import { Check } from 'react-feather';
import type { ToastComponentProps } from './interfaces';
import styles from './style.module.css';
import * as Toast from './Toast.Base';

type Props = ToastComponentProps;

export const Success = (props: Props) => {
  return (
    <Toast.Base
      Icon={Check}
      iconClassName={styles.success}
      body={props.body}
      title={props.title} />
  );
};

Success.displayName = 'Toast.Success';